var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5762 7.48016C20.8414 7.16195 20.7984 6.68903 20.4802 6.42385C20.1619 6.15868 19.689 6.20167 19.4239 6.51988L14.0332 12.9887C12.9503 14.2881 12.1886 15.1994 11.5279 15.796C10.8826 16.3787 10.4373 16.5639 10 16.5639C9.56276 16.5639 9.11742 16.3787 8.47213 15.796C7.81143 15.1994 7.04969 14.2881 5.96686 12.9887L4.57618 11.3199C4.31101 11.0017 3.83809 10.9587 3.51988 11.2239C3.20167 11.489 3.15868 11.9619 3.42385 12.2802L4.85312 13.9953C5.88839 15.2376 6.71748 16.2326 7.46684 16.9092C8.24089 17.6082 9.03216 18.0639 10 18.0639C10.9679 18.0639 11.7591 17.6082 12.5332 16.9092C13.2826 16.2326 14.1116 15.2377 15.1469 13.9953L20.5762 7.48016Z",
    fill: "#2D264B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.e95df9cfbc2c41841f54109272dfe244.svg";
export { ForwardRef as ReactComponent };